
const ALL_VIDEOS = [
  {
    id: 1,
    en: { title: 'How to create projects in GanttPRO', duration: '2:35', youtubeId: 'kfZqfuoFSbs' },
    de: { title: 'Wie man Projekte in GanttPRO erstellt', duration: '2:31', youtubeId: 'aXiX64pPrFM' },
    fr: { title: 'Comment créer des projets dans GanttPRO', duration: '2:31', youtubeId: '77TLWkhneoI' },
    kr: { title: 'GanttPRO에서 프로젝트 생성하는 방법', duration: '2:31', youtubeId: 'fF1ivtA2yT8' },
    pt: { title: 'Como criar projetos no GanttPRO', duration: '2:31', youtubeId: 'O5QDMOwNKHU' },
    es: { title: 'Cómo crear proyectos en GanttPRO', duration: '2:31', youtubeId: 'Qow4j9oQwow' },
  },
  {
    id: 2,
    en: { title: 'How to structure your tasks in GanttPRO', duration: '2:13', youtubeId: 'oHvYxFjI0B0' },
    de: { title: 'Wie Sie Ihre Aufgaben in GanttPRO strukturieren', duration: '2:13', youtubeId: 'waAJUfWqiW0' },
    kr: { title: 'GanttPRO에서 작업을 구성하는 방법', duration: '2:12', youtubeId: 'sNv2_gOqktc' },
    pt: { title: 'Como estruturar as suas tarefas em GanttPRO', duration: '2:14', youtubeId: 'M5-maZcpGLo' },
    es: { title: 'Cómo estructurar las tareas en GanttPRO', duration: '2:13', youtubeId: 'lltkRNHzx5s' },
  },
  {
    id: 3,
    en: { title: 'How to Work with Custom Fields in GanttPRO', duration: '2:10', youtubeId: 'abVoAdzQPkA' },
  },
  {
    id: 4,
    en: { title: 'How to Manage Custom Fields at the Account Level in GanttPRO', duration: '2:07', youtubeId: 'EnlCWAUfzGc' },
    de: { title: 'Wie Sie benutzerdefinierte Felder на Kontoebene in GanttPRO verwalten', duration: '2:04', youtubeId: 'agJ-KnnQvU0' },
    fr: { title: 'Comment gérer les champs personnalisés au niveau du compte dans GanttPRO', duration: '2:04', youtubeId: 'kyOMmjKiQkE' },
    kr: { title: 'GanttPRO에서 계정 수준의 사용자 정의 필드를 관리하는 방법', duration: '2:04', youtubeId: 'SJBtNJxTSxk' },
    pt: { title: 'Como gerir campos personalizados ao nível da conta no GanttPRO', duration: '2:06', youtubeId: 'ndlErp4CzGk' },
    es: { title: 'Cómo gestionar campos personalizados a nivel de cuenta en GanttPRO', duration: '2:04', youtubeId: 'KpKj-5H4hII' },
  },
  {
    id: 5,
    en: { title: 'How to share GanttPRO projects with third parties', duration: '1:22', youtubeId: 'gE8kA_Lw-lU' },
    de: { title: 'Wie man GanttPRO Projekte mit Dritten teilt', duration: '1:21', youtubeId: 'dRKR9mjetWc' },
    kr: { title: 'GanttPRO 프로젝트를 타사와 공유하는 방법', duration: '1:21', youtubeId: 'cfA9LdGSKjE' },
    pt: { title: 'Como partilhar projectos GanttPRO com terceiros', duration: '1:21', youtubeId: 'SBrP1Gp_S6w' },
    es: { title: 'Cómo compartir proyectos de GanttPRO con terceros', duration: '1:21', youtubeId: 'JklLSvt9Zvs' },
  },
  {
    id: 6,
    en: { title: 'How to invite team members in GanttPRO', duration: '1:50', youtubeId: 'SZTLPUvZm_0' },
    de: { title: 'Wie man Teammitglieder in GanttPRO einlädt', duration: '1:50', youtubeId: 'Hskp6OPUFbQ' },
    kr: { title: 'GanttPRO에서 팀원을 초대하는 방법', duration: '1:50', youtubeId: '1PS0sbnn-lM' },
    pt: { title: 'Como convidar membros da equipa em GanttPRO', duration: '1:50', youtubeId: '40qAq6OMZzg' },
    es: { title: 'Cómo invitar a miembros del equipo en GanttPRO', duration: '1:50', youtubeId: 'uWVKb9YQ35U' },
  },
  {
    id: 7,
    en: { title: 'How to add new users in GanttPRO', duration: '1:15', youtubeId: 'NISbawxJ-4U' },
    de: { title: 'Wie man neue Benutzer in GanttPRO hinzufügt', duration: '1:15', youtubeId: 'tbJX_mU_6QE' },
    kr: { title: 'GanttPRO에서 새 사용자를 추가하는 방법', duration: '1:15', youtubeId: 'DjlfbTfU0wM' },
    pt: { title: 'Como adicionar novos utilizadores em GanttPRO', duration: '1:15', youtubeId: 'zvXTFdfneZw' },
    es: { title: 'Cómo agregar nuevos usuarios en GanttPRO', duration: '1:15', youtubeId: 'zvXTFdfneZw' },
  },
];

export const getVideoTutorials = (locale = 'en') => {
  return ALL_VIDEOS.map(video => {
    const videoData = video[locale] || video.en;

    return {
      id: video.id,
      title: videoData.title,
      duration: `${videoData.duration} min`,
      youtubeId: videoData.youtubeId,
      thumbnail: `https://img.youtube.com/vi/${videoData.youtubeId}/maxresdefault.jpg`,
    };
  });
};


// export const VIDEO_TUTORIALS = getVideoTutorials(window.user?.locale || 'en');
